/*----------------------------------------------------------------------------*\
    Sticky
    Sticky loader, works with stickyfill:
    https://github.com/wilddeer/stickyfill
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */
/*global Stickyfill */



/*  Component
\*----------------------------------------------------------------------------*/

oy.sticky = {
    init: function () {
        if (oy.cutsMustard) {
            this.setup(document);
        }
    },

    setup: function ($context) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--sticky');

        for (var i = $elements.length - 1; i >= 0; i--) {
            self.setupSingle($elements[i]);
        }
    },

    setupSingle: function ($context) {
        if ($context && !$context.classList.contains('is-initialised')) {
            Stickyfill.add($context);
            $context.classList.add('is-initialised');
            $context.classList.add('o-sticky');
        }
    },

    destroy : function($context) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--sticky');

        for(var i= $elements.length-1; i>=0; i--) {
            self.destroySingle($elements[i]);
        }
    },

    destroySingle : function($context) {
        if ($context && $context.classList.contains('is-initialised')) {
            Stickyfill.remove($context);
            $context.classList.remove('is-initialised');
            $context.classList.remove('o-sticky');
        }
    }
};

window.addEventListener('load', function () {
    oy.sticky.init();
}, false);